import { Button, Modal } from '../../../../../components'
import { useAppDispatch } from '../../../../../redux/hook'
import { SHOW_NOTIFICATION } from '../../../../../redux/slices/showNotificationSlice'
import { delResource } from '../../api'
import '../../pages/index.css'
import { deleteresource } from '../../slice/resoucesSlice'
import { DelTaskIprops } from '../type'

const DelTask = ({ show, onClose, data }: DelTaskIprops) => {
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title="Delete Task"
            body={
                <>
                    <p className="del-desc">
                        Are you sure you want to delete this task ?
                    </p>
                    <div className="footer-block">
                        <Button
                            type="submit"
                            onClick={async () => {
                                try {
                                    // Call the asynchronous function and wait for its result
                                    await delResource(data.id)
                                    dispatch(
                                        SHOW_NOTIFICATION({
                                            type: 'success',
                                            message:
                                                'Task deleted successfully',
                                        })
                                    )

                                    // Dispatch the action with the data if needed

                                    dispatch(deleteresource(data.id))

                                    // You can also use the data received from the API if needed
                                } catch (err) {
                                    // Handle any errors here
                                    console.error(
                                        'Error fetching holidays:',
                                        err
                                    )
                                }

                                onClose(false)
                            }}
                        >
                            YES
                        </Button>
                        <Button
                            type="submit"
                            variant="outline-success"
                            onClick={() => onClose(false)}
                        >
                            NO
                        </Button>
                    </div>
                </>
            }
            onSuccess={() => {
                onClose(false)
            }}
        />
    )
}
export default DelTask
